import React from "react"
import {TextModel} from "models/Text"
import {SortInput} from "./components"

interface StandardSortInputProps {
    text: TextModel
    toggleDropdown: () => void
}

export const StandardSortInput = ({text, toggleDropdown}: StandardSortInputProps) => {
    return (
        <SortInput data-testid="plp-filters-sort-btn" onClick={toggleDropdown}>
            <span data-testid="desktop-sort-label-text">{text.labels.sortDropdown}</span>
        </SortInput>
    )
}

export default StandardSortInput
